// ECC Components
import Vue from 'vue';
import ECCReferences from '@/components/ecc/ecc-references.vue';
import SVGMap from '@/components/ecc/svg-map.vue';

Vue.component('ecc-references', ECCReferences);
Vue.component('svg-map', SVGMap);



// WEBPACK FOOTER //
// ./src/app/ecc.js